import { render, staticRenderFns } from "./designSurvey.vue?vue&type=template&id=4fd3830f&scoped=true"
import script from "./designSurvey.vue?vue&type=script&lang=js"
export * from "./designSurvey.vue?vue&type=script&lang=js"
import style0 from "./designSurvey.vue?vue&type=style&index=0&id=4fd3830f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3830f",
  null
  
)

export default component.exports